import { render, staticRenderFns } from "./orderDetailsPopup.vue?vue&type=template&id=6db95746&"
import script from "./orderDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./orderDetailsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports